import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import {Row, Col} from "react-bootstrap";
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {CircularProgress} from "@material-ui/core";

export default function SelectInput(props) {

  const {
    errors,
    selectOptions,
    id,
    variant,
    helpText,
    inputColumnSize,
    hideEmptyOption,
    endAdornment,
    loadingList,
    ...textFieldProps
  } = props;

  const columnSize = inputColumnSize || 12;

  const empty = [<option aria-label="None" value="" key={0}/>];

  const menuItems = selectOptions && selectOptions.map((option, key) => {
    return <option value={option.value} key={key + 1} disabled={option.disabled}>{option.label}</option>
  });

  var allMenuItems;

  if (selectOptions && hideEmptyOption) {
    allMenuItems = menuItems;
  } else if (selectOptions) {
    allMenuItems = empty.concat(menuItems);
  } else {
    allMenuItems = empty;
  }

  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl
          fullWidth
          variant={variant || "filled"}
          error={!!errors}
        >
          <InputLabel htmlFor={id}>{props.label}</InputLabel>
          <Select
            native
            {...textFieldProps}
            inputProps={{
              id: id,
            }}
            IconComponent={loadingList ? () => {
              return <CircularProgress className="mr-3" size={30} thickness={4.5} />
            }:  ArrowDropDownIcon 
            }
            endAdornment={endAdornment}
          >
            {allMenuItems}
          </Select>
          <FormHelperText id={`${id}-helper-text`}
                          aria-describedby={`${id}-helper-text`}>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText}>
              <InfoIcon color="action"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

SelectInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
  errors: PropTypes.object,
  hideEmptyOption: PropTypes.bool,
  helpText: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/SelectInput.js